import { INote, RenderNotes } from 'common/render-notes.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { ITideMarkerData } from 'types/tides.js';
import { TidesTable } from './tides-table.js';

export type ITideArr = {
  tideData: ITideMarkerData[];
  day: string;
};

export interface ITidesTimetable {
  data: Array<ITideArr>;
  headers: Array<string>;
  notes: Array<INote>;
}

export const TidesTimetableEntry = ({ config, modulePath, isDrawer }: IModule<ITidesTimetable>) => {
  const { notes, data, headers } = config;

  return (
    <Tile dataModule="tides-t-dm" config={config}>
      <div className="Tile-body Tile-body--noPadding">
        <TileBodyHeaderV2 config={config} modulePath={modulePath} isDrawer={isDrawer} />
        <TidesTable data={data} headers={headers} />
        <div className="u-p-responsive">
          <RenderNotes notes={notes} />
        </div>
      </div>
    </Tile>
  );
};
